export const fileformats_index = ['fileformats.index']
export const fileformats_create = ['fileformats.create']
export const fileformats_edit = ['fileformats.edit']

export default [].concat(
    fileformats_index,
    fileformats_create,
    fileformats_edit
)
